<template>
  <div class="orderDetail">
    <div class="orderDetail_head">
            <span>
              独角兽 {{ detailsdata.site_name }} No.{{ detailsdata.site_id }}
            </span>
    </div>
    <div class="orderDetail_content">
            <span class="num_text">
                <span>{{ detailsdata.oil_name }}</span>
                <span>{{ detailsdata.num }}升</span>
                <span v-show="details_complete" class="iconfont icon-duihao"></span>
                <span v-show="!details_complete" class="iconfont icon-cuo"></span>
            </span>
      <span class="time_text" v-if="detailsdata.order_type==3">单价：{{ detailsdata.total_money }}元</span>
      <span>车牌：{{ detailsdata.car_number }}</span>
      <span class="time_text">{{ detailsdata.create_time }}</span>
    </div>
    <div class="bts">
      <div>
        <div @click="goHome">操作成功</div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "../common";
import wx from "weixin-js-sdk";

export default {
  name: "orderDetail",
  data() {
    return {
      detailsdata: "",
      details_complete: true,//订单是否完成
      token: ""
    }
  },
  methods: {
    goHome() {
      this.$router.replace("/");
    }
  },
  mounted() {
    //判断cookie中是否存在token
    let ifcookietoken = document.cookie.indexOf("token=") != -1;
    let url = 'wx/orderDetail';
    if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
      this.token = JSON.parse(common.getlocalStorage("userInfo")).token;
    } else if (ifcookietoken) {
      this.token = common.getCookie("token");
    } else if (this.$router.currentRoute.query.app_id == "xiangmeng") {
      this.app_id = this.$router.currentRoute.query.app_id;
      url = 'wx/putbox/orderDetail';
    } else {
      this.$router.replace({name: 'login'});
    }
    let order_id = this.$router.currentRoute.params.order_id;
    let token = this.token;
    let querystring = require('querystring');
    this.$api.post(url,
        querystring.stringify({
          order_id,
          token
        })
    ).then(data => {
      if (data.data.status == 1) {
        this.detailsdata = data.data.data;
      } else {
        this.details_complete = false;
        common.toast(data.data.msg);
      }
    }).catch(err => {
      console.log(err);
    })
    wx.getLocation({
      type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      success: res => {
        let querystring = require('querystring');
        this.$api.post('wx/User/getLocation',
            querystring.stringify({
              latitude: res.latitude,
              longitude: res.longitude,
              token: token,
              action: "order_detail",
            })
        )
      }
    });
  }
}
</script>

<style>
.orderDetail {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: white;
  display: -webkit-flex;
  flex-direction: column;
  font-size: .8rem;
}

.orderDetail > .orderDetail_head {
  background: #f5f5f5;
  width: 100%;
  height: 1.5rem;
  margin: .3rem 0;
  padding: 0 .5rem;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.45rem;
}

.orderDetail_content {
  width: 100vw;
  height: 50vh;
  background: white;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: space-around;
}

.num_text {
  color: #0097fe;
  font-size: 1rem;
}

.time_text {
  font-size: .6rem;
}

.orderDetail .icon-cuo {
  font-size: 2rem;
}

.orderDetail .icon-duihao {
  font-size: 2rem;
}

.orderDetail .bts {
  width: 60vw;
  height: 8vh;
  text-align: center;
  margin: 10vh auto;
  line-height: 8vh;
  color: white;
  font-size: .6rem;
  border-radius: 8px;
  font-weight: bold;
  background: #0097fe;
}

.addClass {
  padding: 20px !important;
}

.addClass > span {
  padding-top: 0 !important;
}
</style>
    


// WEBPACK FOOTER //
// src/components/orderDetail.vue